// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Form, FormGroup, Label } from "@components";
import { reduxForm, Field } from "redux-form";
import type { FormProps } from "redux-form";
import { DatePickerFormWrapper } from "@components/form";
import moment from "moment";
import config from "@config";
type Props = $Exact<{
  onSubmit: () => void,
  initialize: Function,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AbsenceNotesFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.handleSubmit();
  };

  UNSAFE_componentWillMount() {
    this.props.initialize(
      this.props.initVals
        ? { ...this.props.initVals }
        : {
            fromDate: moment()
              .subtract(365, "days")
              .format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
          },
    );
  }

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit} className="d-flex">
        <FormGroup className="p-0 mr-3">
          <Label for="fromDate">{this.props.t("DATE_FROM")}</Label>
          <Field
            name="fromDate"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, id: "fromDate" }}
          />
        </FormGroup>
        <FormGroup className="p-0 mr-3">
          <Label for="toDate">{this.props.t("DATE_TO")}</Label>
          <Field
            name="toDate"
            component={DatePickerFormWrapper}
            customProps={{ dateFormat: config.dateFormatBE, id: "toDate" }}
          />
        </FormGroup>
        <div className="pt-4">
          <Button type="submit" materialIcon="replay_circle_filled">
            {this.props.t("SUBMIT")}
          </Button>
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  form: "absence-notes-filters",
})(localize()(AbsenceNotesFilter));
